<template>
  <VerticalNavigator>
    <Breadcrumb
      :links="[{
        title: 'RutSolve',
        routeName: 'index'
      }, {
        title: 'Trademarks',
        routeName: 'trademarks'
      }]"
      title="Create"
    />
    <h1>
      Create Trademark
    </h1>
    <TrademarkEditor v-model:value="trademark" />
    <br>
    <Button
      title="Cancel"
      @click="trademarkRedirect()"
    />
    <Button
      title="Save"
      @click="save()"
    />
  </VerticalNavigator>
</template>

<script setup lang="ts">
  import Button from "@/components/button.vue"
  import TrademarkEditor from "@/components/editors/trademark.vue"
  import VerticalNavigator from "@/layouts/vertical_navigator.vue"
  import Breadcrumb from "@/components/breadcrumb.vue"
  import {Trademark as TrademarkResolver} from "@/endpoints/rutsolve/gql/resolvers/trademark"
  import {Trademark} from "@/endpoints/rutsolve/gql/generated/graphql"
  import router from "@/router"
  import {ref} from "vue"

  const trademarkResolver = new TrademarkResolver()
  const trademark = ref<Trademark>({})

  async function save() {
    await trademarkResolver.create(trademark.value)
    trademarkRedirect()
  }

  function trademarkRedirect() {
    router.push({
      name: "trademarks"
    })
  }
</script>
